import React, { useState } from "react";
import callApi from "../../../../../utils/api-client";
import { PosAcc } from "../../../../../types/pos";
import { useDispatch } from "react-redux";
import { constants } from "../../../../../common/constants/constants";
import { ToastNotification } from "../../../../../common/components/toastNotification/ToastNotification";
import successToast from "../../../../../assets/images/successToast.svg";
import errorToast from "../../../../../assets/images/errorToast.svg";
import { updateIsLoading } from "../../../../../reducerSlices/loaderSlice";
import { useNavigate } from "react-router-dom";
import { IRetailPosFormData } from "../../../../../models/IRetailPosFormProps";
import RetailPosForm from "../RetailPosForm/RetailPosForm";

function LinkRetailPos() {
  const [isLoading, setIsLoading] = useState(false);
  const [toastData, setToastData] = useState(constants.defaultToastData);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFormSubmit = async (data: IRetailPosFormData) => {
    setIsLoading(true);

    try {
      const posData: Omit<PosAcc, "id"> = {
        api_key: null,
        secret_key: null,
        pos_base_url: null,
        business_setup_id: data.business.id,
        retail_api_key: data.retailApiKey,
        retail_secret_key: data.retailSecretKey,
        retail_pos_base_url: data.retailBaseUrl,
        retail_pos_comapany_name: data.retailCompanyName,
      };
      // Simulate API call
      dispatch(updateIsLoading(true));
      await callApi(
        "admin/pos/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(posData),
        },
        "createPOSLink"
      );
      setToastData({
        message: "POS linked successfully.",
        status: "Success",
      });
      dispatch(updateIsLoading(false));
      navigate("/admin/pos");
      return true;
    } catch (error) {
      console.error("Error saving configuration:", error);
      setToastData({
        message: "Error saving configuration. Please try again.",
        status: "Fail",
      });
      return false;
    } finally {
      setTimeout(() => {
        setToastData(constants.defaultToastData);
      }, 10000);
      setIsLoading(false);
      dispatch(updateIsLoading(false));
    }
  };

  // Example initial data (optional)
  const initialFormData: IRetailPosFormData = {
    retailBaseUrl: "",
    retailApiKey: "",
    retailSecretKey: "",
    retailCompanyName: "",
    business: {
      id: "",
      name: "",
    },
    businessSearchName: "",
  };

  return (
    <div style={{ padding: "20px" }}>
      <RetailPosForm
        onSubmit={handleFormSubmit}
        initialData={initialFormData}
        isLoading={isLoading}
      />
      {toastData?.message && (
        <ToastNotification
          icon={toastData.status === "Success" ? successToast : errorToast}
          content={toastData?.message}
          position={"top-right"}
          autoClose={2000}
        />
      )}
    </div>
  );
}

export default LinkRetailPos;
